import { createMutation } from '@/mutations'
import {
  attachOutfitToCapsules,
  createOutfit,
  deleteOutfit,
  patchOutfit,
  type AttachOutfitCapsulesResponse,
  type CreateOutfitBody,
  type CreateOutfitResponse,
  type DeleteOutfitResponse,
  type PatchOutfitBody,
  type PatchOutfitResponse,
} from '@/features/style-space/api'
import { styleSpaceQueriesOf } from '@/queries/style-space'

/** An outfit write changes capsule counts and inventories too. */
const invalidateOutfitReaders = styleSpaceQueriesOf(
  'outfits',
  'capsules',
  'capsule',
  'available-items',
  'wardrobe-item',
)

export const useCreateOutfitMutation = () =>
  createMutation<CreateOutfitResponse, CreateOutfitBody>({
    mutationFn: async (body) => {
      const response = await createOutfit(body)
      return response.data
    },
    invalidateQueries: invalidateOutfitReaders,
  })

export interface PatchOutfitVariables {
  outfitId: number
  body: PatchOutfitBody
}

export const usePatchOutfitMutation = () =>
  createMutation<PatchOutfitResponse, PatchOutfitVariables>({
    mutationFn: async ({ outfitId, body }) => {
      const response = await patchOutfit(outfitId, body)
      return response.data
    },
    invalidateQueries: invalidateOutfitReaders,
  })

export const useDeleteOutfitMutation = () =>
  createMutation<DeleteOutfitResponse, { outfitId: number }>({
    mutationFn: async ({ outfitId }) => {
      const response = await deleteOutfit(outfitId)
      return response.data
    },
    invalidateQueries: invalidateOutfitReaders,
  })

export const useAttachOutfitToCapsulesMutation = () =>
  createMutation<AttachOutfitCapsulesResponse, { outfitId: number; capsuleIds: number[] }>({
    mutationFn: async ({ outfitId, capsuleIds }) => {
      const response = await attachOutfitToCapsules(outfitId, capsuleIds)
      return response.data
    },
    invalidateQueries: invalidateOutfitReaders,
  })
